import { render, staticRenderFns } from "./SosialisasiTanam.vue?vue&type=template&id=3eb787f6"
import script from "./SosialisasiTanam.vue?vue&type=script&lang=js"
export * from "./SosialisasiTanam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports